import React, { useCallback, useEffect } from "react";
import { useMap } from "react-leaflet";
import * as L from "leaflet";

export const RemoveDefaultZoom = () => {
  const map = useMap();
  useEffect(() => {
    const anyMap = map as any;
    if (anyMap.zoomControl) map.removeControl(anyMap.zoomControl);
  }, [map]);
  return null;
};

export const InvalidateOn: React.FC<{ deps: React.DependencyList }> = ({ deps }) => {
  const map = useMap();
  useEffect(() => {
    const t = setTimeout(() => map.invalidateSize(), 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return null;
};

export const ChooseViewControl: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const map = useMap();
  const handle = useCallback((e?: Event) => { e?.preventDefault(); onClick(); }, [onClick]);

  useEffect(() => {
    const Ctl = (L.Control as any).extend({
      options: { position: "bottomright" },
      onAdd: function () {
        const container = L.DomUtil.create("div", "leaflet-bar chooseview-control br-fabs");
        const a = L.DomUtil.create("a", "", container);
        a.href = "#";
        a.title = "Choose view";
        a.innerHTML = `
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" style="vertical-align:middle">
            <path d="M12 3l9 5-9 5-9-5 9-5zm0 8l9 5-9 5-9-5 9-5z" fill="currentColor"/>
          </svg>`;
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.on(a, "click", L.DomEvent.stop);
        L.DomEvent.on(a, "click", handle);
        return container;
      }
    });
    const ctrl = new Ctl();
    map.addControl(ctrl);
    return () => { map.removeControl(ctrl); };
  }, [map, handle]);

  return null;
};
